const apiBaseUrl = import.meta.env.VITE_API_BASE_URL
const apiBaseQcUrl = import.meta.env.VITE_API_BASE_QC_URL

export const error = async (resp: Response) => {
  const error = new Error(`${await resp.text()}`)
  error.name = `${resp.status}`
  return error
}

export default {
  token: () => `${apiBaseUrl}/api/auth/token`,
  profile: () => `${apiBaseUrl}/api/user/profile`,
  password: () => `${apiBaseUrl}/api/user/password`,
  ossToken: () => `${apiBaseUrl}/api/omics/token`,
  ossTokenLong: () => `${apiBaseUrl}/api/omics/token_long`,

  designs: () => `${apiBaseUrl}/api/omics/design`,
  design: (id: number) => `${apiBaseUrl}/api/omics/design/${id}`,

  dnas: () => `${apiBaseUrl}/api/omics/quartet/dna`,
  dna: (id: number) => `${apiBaseUrl}/api/omics/quartet/dna/${id}`,
  dnaProgress: (id: number) => `${apiBaseUrl}/api/omics/quartet/dna/${id}/progress`,
  dnaAnalysis: (id: number) => `${apiBaseUrl}/api/omics/quartet/dna/${id}/analysis`,
  dnaReport: () => `${apiBaseUrl}/api/omics/quartet/dna/report`,

  rnas: () => `${apiBaseUrl}/api/omics/quartet/rna`,
  rna: (id: number) => `${apiBaseUrl}/api/omics/quartet/rna/${id}`,
  rnaReport: (id: number) => `${apiBaseUrl}/api/omics/quartet/rna/${id}/report`,

  proteins: () => `${apiBaseUrl}/api/omics/quartet/protein`,
  protein: (id: number) => `${apiBaseUrl}/api/omics/quartet/protein/${id}`,
  proteinReport: (id: number) => `${apiBaseUrl}/api/omics/quartet/protein/${id}/report`,

  metabolisms: () => `${apiBaseUrl}/api/omics/quartet/metabolism`,
  metabolism: (id: number) => `${apiBaseUrl}/api/omics/quartet/metabolism/${id}`,
  metabolismReport: (id: number) => `${apiBaseUrl}/api/omics/quartet/metabolism/${id}/report`,

  plasmixProteins: () => `${apiBaseUrl}/api/omics/plasmix/protein`,
  plasmixProtein: (id: number) => `${apiBaseUrl}/api/omics/plasmix/protein/${id}`,
  plasmixProteinReport: (id: number) => `${apiBaseUrl}/api/omics/plasmix/protein/${id}/report`,

  plasmixMetabolisms: () => `${apiBaseUrl}/api/omics/plasmix/metabolism`,
  plasmixMetabolism: (id: number) => `${apiBaseUrl}/api/omics/plasmix/metabolism/${id}`,
  plasmixMetabolismReport: (id: number) => `${apiBaseUrl}/api/omics/plasmix/metabolism/${id}/report`,

  qcRna: () => `${apiBaseQcUrl}/api/qc/quartet/rna`,
  qcProtein: () => `${apiBaseQcUrl}/api/qc/quartet/protein`,
  qcMetabolism: () => `${apiBaseQcUrl}/api/qc/quartet/metabolism`,
  qcPlasmixProtein: () => `${apiBaseQcUrl}/api/qc/plasmix/protein`,
  qcPlasmixMetabolism: () => `${apiBaseQcUrl}/api/qc/plasmix/metabolism`,

  allUsers: () => `${apiBaseUrl}/api/admin/users`,
  user: (id: number) => `${apiBaseUrl}/api/admin/users/${id}`,
  userKey: (id: number) => `${apiBaseUrl}/api/admin/users/${id}/key`,
  users: ({ page, pageSize }: { page: number; pageSize: number }) =>
    `${apiBaseUrl}/users/?page=${page}&pageSize=${pageSize}`,

  adminDesigns: () => `${apiBaseUrl}/api/admin/omics/design`,
  adminDesign: (id: number) => `${apiBaseUrl}/api/admin/omics/design/${id}`,

  adminDnas: () => `${apiBaseUrl}/api/admin/omics/quartet/dna`,
  adminDna: (id: number) => `${apiBaseUrl}/api/admin/omics/quartet/dna/${id}`,
  adminDnaScore: (id: number) => `${apiBaseUrl}/api/admin/omics/quartet/dna/${id}/score`,

  adminRnas: () => `${apiBaseUrl}/api/admin/omics/quartet/rna`,
  adminRna: (id: number) => `${apiBaseUrl}/api/admin/omics/quartet/rna/${id}`,
  adminRnaNotes: (id: number) => `${apiBaseUrl}/api/admin/omics/quartet/rna/${id}/notes`,

  adminProteins: () => `${apiBaseUrl}/api/admin/omics/quartet/protein`,
  adminProtein: (id: number) => `${apiBaseUrl}/api/admin/omics/quartet/protein/${id}`,
  adminProteinNotes: (id: number) => `${apiBaseUrl}/api/admin/omics/quartet/protein/${id}/notes`,

  adminMetabolisms: () => `${apiBaseUrl}/api/admin/omics/quartet/metabolism`,
  adminMetabolism: (id: number) => `${apiBaseUrl}/api/admin/omics/quartet/metabolism/${id}`,
  adminMetabolismNotes: (id: number) => `${apiBaseUrl}/api/admin/omics/quartet/metabolism/${id}/notes`,

  adminPlasmixProteins: () => `${apiBaseUrl}/api/admin/omics/plasmix/protein`,
  adminPlasmixProtein: (id: number) => `${apiBaseUrl}/api/admin/omics/plasmix/protein/${id}`,
  adminPlasmixProteinNotes: (id: number) => `${apiBaseUrl}/api/admin/omics/plasmix/protein/${id}/notes`,

  adminPlasmixMetabolisms: () => `${apiBaseUrl}/api/admin/omics/plasmix/metabolism`,
  adminPlasmixMetabolism: (id: number) => `${apiBaseUrl}/api/admin/omics/plasmix/metabolism/${id}`,
  adminPlasmixMetabolismNotes: (id: number) => `${apiBaseUrl}/api/admin/omics/plasmix/metabolism/${id}/notes`,

  allProjects: () => `${apiBaseUrl}/projects`,
  project: (id: string) => `${apiBaseUrl}/projects/${id}`,
  projects: ({ page, pageSize }: { page: number; pageSize: number }) =>
    `${apiBaseUrl}/projects/?page=${page}&pageSize=${pageSize}`,
}
